<template>
    <section class="quick">
        <header-com class='bgw'>
            <div class="location">
                <span class="f26">专业顾问直接诊断</span>
            </div>
        </header-com>
        <div class='line_bg'></div>
        <div class='content_card'>
            <div class="title f32">
                <div class="block"></div>
                <span>预约信息</span>
            </div>

            <div class='category_list'>
                <div v-for='(item,index) in categoryList' :key='index'>
                    <img :src="'/images/newOrder/'+item.imgPath+'.png'" v-show='!item.num'>
                    <img :src="'/images/newOrder/'+item.imgPath+'1.png'" v-show='item.num'>
                    <span>{{item.name}}</span>
                    <num-count 
                        style="margin-top:5px;"
                        :large='false'
                        :num='item.num'
                        @plus='item.num++'
                        @minus='item.num?item.num--:0'
                    >
                    </num-count>
                </div>
            </div>
            <div class='categoty_tips'>
                *请选择您需要养护的品类数量，至少选择一个品类
            </div>

        </div>
        <div class='line_bg'></div>
        <select-address class='address' @changeType='changeType' :sendFrom='sendFrom' @changeAdr='changeAdr' @changeDate='changeDate' @action='action' ref='setAdr'></select-address>
        <div class='content_card pdb'>
            
            <field @changeMessage='changeMessage'></field>
        </div>

        <div class="tool-bar f28">
            <div>
                 <!-- <div  id="alldo" style="float: left;position:relative;left:110px;width:100px;">
                </div> -->
                
               
                <button class="primary pay" style="float:right" @click='submit()'>立即预约</button>
                <!-- <button class="kefu"  style="float: right;">
                    <img src="/images/base/wechart-icon.png" class="icon" alt="">
                    <span>问客服</span>
                </button> -->
                <button class="kefu2" @click='toPublic' style="float: right;">
                    <img src="/images/base/wechart-icon.png" class="icon" alt="">
                    <span>问客服</span>
                </button>
            </div>
        </div>
        <!-- 选择地址 -->
    </section>
</template>

<script>
  import homeApi from '@/axios/home'
  import publicObj from '@/assets/js/public';
  import myApi from '@/axios/my'
  import zhugeObj from '@/assets/js/track'
  import { Toast,Dialog } from 'vant';
  import getWXConfig from "@/assets/js/wx.config";
  import orderApi from '@/axios/order';
  export default {
    name: 'index',
    data () {
      return {
            timeShow : false,
            isIPX:false,
            message : '',
            categoryList : [
                {
                    imgPath : 'package',
                    name : '包包',
                    key : 3,
                    num : 0
                },
                {
                    imgPath : 'shoes',
                    name : '鞋靴',
                    key : 4,
                    num : 0
                },
                {
                    imgPath : 'pajamas',
                    name : '衣裤',
                    key : 5,
                    num : 0
                },
                {
                    imgPath : 'accessories',
                    name : '配饰',
                    key : 6,
                    num : 0
                },
            ],
           
            sendFrom : {
                sendType : 40,
                customerAddressId : '',
                pickingDate : '',
                pickingTime : '',
            }
            
      }
    },
    computed: {
        defultAdr(){
            let items = '';
            this.adrList.forEach((item,index)=>{
                if(item.isDefault){
                    items = item;
                }
            })
            if(items){
                return items;
            }else{
                return {};
            }
        }
    },
    created() {
        // this.isIPX=publicObj.isIPX();
        zhugeObj.track({
            title : '直接寄包页曝光',
        })

    },
    mounted(){
        getWXConfig()

        // 屏蔽微信客服
        // var dom = document.getElementById('alldo') //
        // let urlend = encodeURIComponent(window.location.href)
        // dom.innerHTML = '<wx-open-launch-weapp path="pages/kefu/index.html?h5Url=我正在浏览直接寄包页：'+urlend+'" id="launch-btn"   username="gh_f36f18f6beed"><template><div style="width:100px;height:45px;"></div></template></wx-open-launch-weapp>'
       
        // var launchBtn = document.getElementById('launch-btn')
        // if (!launchBtn) {
        // return
        // }
        // launchBtn.addEventListener('launch', function (e) {
        //     zhugeObj.track({
        //         title: "直接寄包页-问客服按钮-点击"
        //     });
        // })
        // launchBtn.addEventListener('error', function (e) {
        // console.log('fail', e.detail)
        // })
    },
    methods: {
      toPublic() {
        window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzAwNjUzNzQyNA==&scene=124#wechat_redirect'
      },
        action(){
          this.submit();
        },
        changeDate(data,time){
          this.sendFrom.pickingDate = data;
          this.sendFrom.pickingTime = time;
        },
        changeAdr(element){
        
          this.sendFrom.customerAddressId = element.id;
        },
        changeType(index){
          this.sendFrom.sendType = index;
        },  
        changeMessage(mes){
            this.message = mes;
        },
       
        submit(){
            //各种验证
            let goodsNum = false;
            this.categoryList.forEach((item,index)=>{
                if(item.num != 0){
                    goodsNum = true;
                }
            })
            if(!goodsNum){
                Toast('请至少设置一个物品');
                return;
            }

            
            let params = {
                pickingWay : this.sendFrom.sendType,
                remarks : this.message,
                action : 'direct',
                categoryRemark : []
            }
            
            this.categoryList.forEach((item,index)=>{
                let obj = {};
                obj.id = item.key;
                obj.count = item.num;
                params.categoryRemark.push(obj);
            })
            params.categoryRemark = JSON.stringify(params.categoryRemark);

            if(this.sendFrom.sendType == 40){
               
                params.addressId =  this.sendFrom.customerAddressId;
                params.pickingDate = this.sendFrom.pickingDate;
                params.pickingTime = this.sendFrom.pickingTime;
                 //参数验证
                if(!params.addressId){
                    Toast('请选择地址');
                    return;
                }

                if(!params.pickingDate){
                    Toast('请选择上门时间');
                    this.$refs.setAdr.timeShowAction(1);
                    return;
                }
            }
            zhugeObj.track({
                title : '直接寄包-立即预约',
                content : {
                    '品类-数量' :  params.categoryRemark,
                    '备注' : params.remarks,
                    '邮递' : params.pickingWay == 10?'自己快递':'顺丰上门',
                    '上门时间' : params.pickingDate?params.pickingDate:'无'
                }
            })

            let paramsOrder = {
                current : 1,
                size : 1000,
            }
            let orderArr = [];
            orderApi.getBookingsOrder(paramsOrder).then((res)=>{
                // orderArr = res.records.map((item)=>{
                //     return item.stateText
                // })
                
                // if(orderArr.includes('待发货') || orderArr.includes('待取件') || orderArr.includes('待付款')){
                //     Dialog.confirm({
                //         title: '',
                //         message: '您有未完结预约单，是否继续预约?',
                //         confirmButtonText : '否',
                //         cancelButtonText : '是'
                //     }).then(() => {
                        
                //     }).catch(() => {
                //         // on cancel
                //         this.addBookingOrder(params); 
                //     });
                // }else{
                //     this.addBookingOrder(params); 
                // }
                let tag = false;
            
                res.records.forEach((element)=>{
                    if(element.bookingsCuringServiceBoList){
                        if((element.stateText == '待发货' || element.stateText == '待取件' || element.stateText == '待付款') && element.bookingsCuringServiceBoList[0].classify == 10){
                            tag = true;
                        }
                    }

                })
                if(tag){
                    Dialog.confirm({
                        title: '',
                        message: '您有未完结预约单，是否继续预约?',
                        confirmButtonText : '否',
                        cancelButtonText : '是'
                    }).then(() => {
                        // this.addBookingOrder(params); 
                    }).catch(() => {
                        // on cancel
                        this.addBookingOrder(params); 
                    });
                }else{
                    this.addBookingOrder(params); 
                }

            })
            // homeApi.submitCart(params).then((res)=>{
            //     this.$router.replace({name:'orderList',params:{type:1}})
            // })
        },
        addBookingOrder(params){
            homeApi.submitCart(params).then((res)=>{
                this.$router.replace({name:'orderList',params:{type:1}})
            })
        },
    
      
    }
  }
</script>

<style scoped lang="scss">
    .coupon{
        display: flex;
        justify-content: space-between;
        margin-top: 32px;
        border-bottom: 1px dashed #e1e1e1;
        padding-bottom: 40px;
        .payTypeOther{
            display: flex;
            &>div{
                display:flex;
                line-height: 35px;
                margin-left: 40px;
                &>div{
                    margin-left: 10px;
                 
                }
            }
        }
    }
    .bgw{
        background: #fff!important;
    }
  

    .expressDero{
        line-height: 50px;
    }
    .pdb{
        margin-bottom: 150px;
        padding-top:0px!important;
    }
    .tool-bar{
      position: fixed;
      width: 100%;
      display: flex;
      z-index: 9;
      align-items: center;
      height: 108px;
      bottom: 0px;
      left: 0;
      background:rgba(255,255,255,1);
      box-shadow:0px -2px 20px 0px rgba(0,0,0,0.06);
      justify-content: flex-end;
    
      .pay{
          margin-right: 30px;
      }
    }

    .choseType{
      
        color:#4A4A4A;
        font-size: 28px;
        display: flex;
        justify-content: flex-end;
        line-height: 28px;
        margin-top: 25px;
        padding-right:50px;
        // font-weight:600;
        position: relative;
        .expressTypeTitle{
            color:#4A4A4A;
       
            font-size: 24px;
            line-height: 50px;
        }
        img{
            width:35px;
            position: absolute;
            right: 0;
            top:20px;
        }
    }

    .expressTypeName{
        line-height: 50px;
    }
    
    .expressType{
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        line-height: 28px;
        padding-right:50px;
        .expressTypeTitle{
            color:#4A4A4A;
            font-weight:600;
            font-size: 24px;
            line-height: 50px;
        }
    }
    
    .category_list{
        display: flex;
        justify-content:space-around;
        border-bottom: 1px solid #e1e1e1;
        padding-bottom:28px;
        img{
            width:112px;
            margin-left: 10px;
        }
        &>div{
            margin-top: 40px;
            display: flex;
            flex-direction: column;
            text-align: center;
            vertical-align: middle;
            &>span{
                margin-top: 12px;
                font-size: 28px;
                color:#9B9B9B;
            }
        }
    }
    .categoty_tips{
        color:#9B9B9B;
        font-size: 24px;
     
        margin-top: 30px;
    }
    .title{
        height: 44px;
        width: 690px;
        display: flex;
        align-items: center;
        font-weight:500;
        .block{
            width:8px;
            height:28px;
            background:rgba(122,223,223,1);
            margin-right: 10px;
        }
    }
    .quick{
        padding-top: 100px;
        padding-bottom: 100px;
    }
    .location{
        position: absolute;
        left: 110px;
        height: 60px;
        display: flex;
        align-items: center;
        img{
        width: 46px;
        height: 44px;
        object-fit: cover;
        margin-right: 14px;
        }
    }
    .line_bg{
        height:20px;
        background: #EDEDED;
    }
    .content_card{
        background: #fff;
        padding-top: 40px;
        padding-left:30px;
        padding-right:30px;
        padding-bottom:30px;
    }
    .kefu,.kefu2{
        width: 192px;
        height: 72px;
        background: #FFFFFF;
        box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
        border-radius: 36px;
        line-height: 72px;
        text-align: center;
        margin: 5px 20px;
        .icon{
            display: inline-block;
            vertical-align: middle;
            width: 40px;
            height: 40px;
            margin: 10px;
        }
    }
    
</style>
